import { render } from "./attributeValues.vue?vue&type=template&id=1e784895&scoped=true&ts=true"
import script from "./attributeValues.vue?vue&type=script&lang=ts"
export * from "./attributeValues.vue?vue&type=script&lang=ts"

import "./attributeValues.vue?vue&type=style&index=0&id=1e784895&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e784895"]])

export default __exports__